<button type="button" mat-icon-button *ngIf="initialized" (click)="reset()"><mat-icon>clear</mat-icon></button>
